export default "__VITE_ASSET__Cbuhj3az__"